/**
 * FAYECREATIONS — Judge.me Homepage Carousel Auto-Scroll
 *
 * Target : .jdgm-carousel-widget (homepage only)
 *          Product page widgets (.jdgm-rev-widg) are never touched.
 * Effect : Slow luxury drift → smooth rewind → repeat
 *          Pauses on hover, touch and manual arrow click.
 *
 * To apply (duplicate theme only — do NOT publish live):
 *   1. Assets → Add new asset → Create blank file → fayecreations-carousel.js
 *   2. Paste this file's contents → Save
 *   3. layout/theme.liquid → find </body> → paste just before it:
 *      {{ 'fayecreations-carousel.js' | asset_url | script_tag }}
 */

(function () {
  'use strict';

  var SPEED        = 0.52;   // px per requestAnimationFrame ≈ 24 px/sec at 60fps
  var TOUCH_RESUME = 2000;  // ms delay before resuming after finger lifts
  var ARROW_PAUSE  = 3000;  // ms pause after manual prev/next arrow click

  function startAutoScroll(track, widget) {
    var paused    = false;
    var rewinding = false;

    function step() {
      if (!paused && !rewinding) {
        track.scrollLeft += SPEED;

        // Near the end — brief pause, then smooth glide back to start
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 8) {
          rewinding = true;
          setTimeout(function () {
            track.scrollTo({ left: 0, behavior: 'smooth' });
            setTimeout(function () { rewinding = false; }, 700);
          }, 400);
        }
      }
      requestAnimationFrame(step);
    }

    // Hover — instant pause, instant resume
    widget.addEventListener('mouseenter', function () { paused = true; });
    widget.addEventListener('mouseleave', function () { paused = false; });

    // Touch — pause on contact, resume after delay (avoids jerky re-engagement)
    var touchTimer;
    widget.addEventListener('touchstart', function () {
      clearTimeout(touchTimer);
      paused = true;
    }, { passive: true });
    widget.addEventListener('touchend', function () {
      touchTimer = setTimeout(function () { paused = false; }, TOUCH_RESUME);
    }, { passive: true });

    // Manual arrows — pause for 3 s then quietly resume
    var arrowTimer;
    [
      widget.querySelector('.jdgm-carousel-controls__prev'),
      widget.querySelector('.jdgm-carousel-controls__next')
    ].filter(Boolean).forEach(function (btn) {
      btn.addEventListener('click', function () {
        clearTimeout(arrowTimer);
        paused = true;
        arrowTimer = setTimeout(function () { paused = false; }, ARROW_PAUSE);
      });
    });

    requestAnimationFrame(step);
  }

  function init() {
    // Exit immediately if no homepage carousel exists on this page
    var widget = document.querySelector('.jdgm-carousel-widget');
    if (!widget) return;

    var track = widget.querySelector('.jdgm-carousel');
    if (track) {
      startAutoScroll(track, widget);
      return;
    }

    // Judge.me injects its carousel asynchronously from CDN.
    // MutationObserver fires the moment it appears in the DOM.
    var observer = new MutationObserver(function () {
      var t = widget.querySelector('.jdgm-carousel');
      if (t) {
        observer.disconnect();
        startAutoScroll(t, widget);
      }
    });
    observer.observe(widget, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
